import http from "@/api/request";
import { DEVICE_OPS_BASE, SHOP_SERVICE_BASE } from "@/config/apiBaseUrlConfig";

import type {
  OpsDevicePageQueryRequest,
  PageDataOpsDevicePageVO,
  PageDataShopPageItemVO,
  ShopDetailVO,
  ShopPageQueryRequest,
  ShopStatusUpdateRequest,
  ShopUpdateRequest,
} from "./type";

/**
 * 分页查询门店列表
 * GET /service-chijing-shop/api/shop/getPage
 * @param params 分页与筛选条件（shopId / agentId / brandTagId / scale 等）
 */
export const getShopPage = (params?: ShopPageQueryRequest) => {
  return http.get<PageDataShopPageItemVO>(`${SHOP_SERVICE_BASE}/getPage`, { params });
};

/**
 * 查询门店详情
 * GET /service-chijing-shop/api/shop/getShop/{id}
 * @param id 门店 ID
 */
export const getShopDetail = (id: string) => {
  return http.get<ShopDetailVO>(`${SHOP_SERVICE_BASE}/getShop/${id}`);
};

/**
 * 更新门店（不含合同授权；停业门店拒绝更新）
 * PUT /service-chijing-shop/api/shop/updateShop/{id}
 * @param id 门店 ID
 * @param data 更新参数
 */
export const updateShop = (id: string, data: ShopUpdateRequest) => {
  return http.put<ShopDetailVO>(`${SHOP_SERVICE_BASE}/updateShop/${id}`, data);
};

/**
 * 切换门店启用/停用状态
 * PUT /service-chijing-shop/api/shop/updateShopStatus/{id}
 * @param id 门店 ID
 * @param data 状态变更参数
 */
export const updateShopStatus = (id: string, data: ShopStatusUpdateRequest) => {
  return http.put<void>(`${SHOP_SERVICE_BASE}/updateShopStatus/${id}`, data);
};

/**
 * 门店绑定 GAMING_PC 分页
 * GET /service-chijing-device/api/ops/device/getPage
 * @param params shopId 必填；可选 deviceStatus、keyword、分页
 */
export const getDevicePage = (params: OpsDevicePageQueryRequest) => {
  return http.get<PageDataOpsDevicePageVO>(`${DEVICE_OPS_BASE}/getPage`, { params });
};
